import { render, staticRenderFns } from "./relevant-products.vue?vue&type=template&id=fcaf79ba&"
import script from "./relevant-products.vue?vue&type=script&lang=js&"
export * from "./relevant-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports